const RTL_LANG_CODES = new Set(['ar', 'ar_ae']);

export function normalizeLangCode(language?: string): string {
  return (language?.trim().toLowerCase() || 'en').split('-')[0];
}

export function isRtlLanguage(language?: string): boolean {
  return RTL_LANG_CODES.has(normalizeLangCode(language));
}

export function getPageDir(language?: string): 'rtl' | 'ltr' {
  return isRtlLanguage(language) ? 'rtl' : 'ltr';
}

export function getPageLang(language?: string): string {
  return normalizeLangCode(language);
}
